/**
 * Generated by orval v8.8.0 🍺
 * Do not edit manually.
 * PatientPortal
 * OpenAPI spec version: v1
 */

export type LoginRequestDeliveryMethods = typeof LoginRequestDeliveryMethods[keyof typeof LoginRequestDeliveryMethods];


export const LoginRequestDeliveryMethods = {
  SMS: 'SMS',
  Email: 'Email',
} as const;
